import { MatDialogRef } from '@angular/material/dialog';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-guidelines',
  templateUrl: './guidelines.component.html',
  styleUrls: ['./guidelines.component.scss']
})
export class GuidelinesComponent implements OnInit {

  constructor(private dialogRef: MatDialogRef<GuidelinesComponent>) { }

  ngOnInit() {
  }

  close() {
    this.dialogRef.close()
  }

}
